import React from "react";

const bannerStyle = {
  background: "linear-gradient(135deg, #33A5FF 0%, #2894E6 100%)",
  borderRadius: "1rem",
  padding: "1.5rem 2rem",
  margin: "1rem 0",
  cursor: "pointer",
  transition: "all 0.3s ease",
  boxShadow: "0 4px 15px rgba(51, 165, 255, 0.25)",
  color: "white",
  display: "flex",
  alignItems: "center",
  gap: "1.5rem",
};

const logoStyle = {
  width: "56px",
  height: "56px",
  borderRadius: "12px",
  flexShrink: 0,
  background: "rgba(255,255,255,0.2)",
  padding: "6px",
};

const textWrapStyle = {
  flex: 1,
  minWidth: 0,
};

const titleStyle = {
  fontSize: "1.05rem",
  fontWeight: "700",
  marginBottom: "0.4rem",
  lineHeight: 1.3,
};

const descStyle = {
  fontSize: "0.85rem",
  opacity: 0.9,
  lineHeight: 1.5,
};

const ctaStyle = {
  display: "inline-block",
  marginTop: "0.75rem",
  padding: "0.4rem 1.2rem",
  background: "rgba(255,255,255,0.2)",
  borderRadius: "0.5rem",
  fontWeight: "600",
  fontSize: "0.8rem",
  border: "1px solid rgba(255,255,255,0.3)",
};

const MyWashBanner = () => {
  return (
    <div
      style={bannerStyle}
      onClick={() => window.open("https://vlasnici.mywash.rs", "_blank")}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(51, 165, 255, 0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(51, 165, 255, 0.25)";
      }}
    >
      <img
        src="https://partneri.mywash.rs/assets/mywash-logo.png"
        alt="MyWash"
        style={logoStyle}
      />
      <div style={textWrapStyle}>
        <h3 style={titleStyle}>Gubite mušterije jer nemaju sitno?</h3>
        <p style={descStyle}>
          MyWash omogućava plaćanje telefonom na vašoj samouslužnoj perionici — za 10 sekundi. Digitalna naplata, više prodaja, manje brige.
        </p>
        <span style={ctaStyle}>Saznaj više →</span>
      </div>
    </div>
  );
};

export default MyWashBanner;
